import React, { Component } from "react";
import axios from "axios";
import {
    ContextualMenu,
    ContextualMenuItemType,
    ConstrainMode,
    DirectionalHint,
    DetailsListLayoutMode,
    Label,
    Link,
    Separator,
    Stack,
    Spinner,
    SpinnerSize,
    ShimmeredDetailsList,
    Sticky,
    StickyPositionType,
    SelectionMode,
    ScrollablePane,
    ScrollbarVisibility,
    DefaultButton,
    PanelType,
    Panel,
    PrimaryButton,
    IRenderFunction,
    IDetailsHeaderProps,
} from "office-ui-fabric-react";
import { MatterItemDateText } from "./Vertical-Timeline/CustomFuntion";

import Moment from "moment";
import { EventEmitter } from "./events";

import Filters from "./filters";

import "../styles/matterlist.css";

const stackTokens = {
    childrenGap: 10,
    padding: 10,
};

interface IFilterType {
    column: string;
    values: [];
}
class MatterList extends Component {
    private _tempFilter: IFilterType[];

    constructor(props: any) {
        super(props);

        const columns = [
            {
                key: "matter_code",
                name: "Matter ID",
                fieldName: "matter_code",
                minWidth: 100,
                maxWidth: 100,
                data: "string",
                isHidden: false,
                isFilterable: false,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false,
                onRender: (item: any) => {
                    return (
                        <div className="matter-holder">
                            <div className="matter-item">
                                <Link
                                    type="submit"
                                    href={
                                        this.state.documentURL +
                                        "/Matter?matterCode=" +
                                        item.matter_code +
                                        "#/Documents"
                                    }
                                    target="_blank"
                                >
                                    {item.matter_code}
                                </Link>
                            </div>
                        </div>
                    );
                },
            },
            {
                key: "description",
                name: "Description",
                fieldName: "description",
                data: "string",
                isHidden: false,
                isFilterable: false,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false,
                onRender: (item: any) => {
                    return <div title={item.description}>{item.description}</div>;
                },
            },
            {
                key: "office",
                name: "Office",
                fieldName: "office",
                data: "string",
                isHidden: false,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false,
            },
            {
                key: "country",
                name: "Jurisdiction",
                fieldName: "country",
                data: "string",
                isHidden: true,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false,
            },
            {
                key: "client_name",
                name: "Client",
                fieldName: "client_name",
                minWidth: 150,
                data: "string",
                isHidden: true,
                isFilterable: false,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: false,
            },
            {
                key: "date_opened",
                name: "Date",
                fieldName: "date_opened",
                data: "date",
                isHidden: false,
                isFilterable: true,
                isSorted: false,
                isFiltered: false,
                SelectedValues: [],
                isResizable: true,
                isSortedDescending: true,
                onRender: (item: any) => MatterItemDateText(item.date_opened),
            },
        ];

        this._tempFilter = [];

        this.state = {
            items: [],
            displayItems: [],
            columns: [],
            tempColumns: columns,
            activeCols: ['matter_code', 'description', 'office','date_opened'],
            settingsMenu: [],
            blocking: true,
            contextualMenuProps: ContextualMenu,
            token: "",
            name: "",
            image: "",
            userName: "",
            userId: "",
            originalURL: "",
            formActionURL: "",
            formTarget: "",
            openPanel: false,
            filterColumn: [],
            filterColumnName: "",
            prevDisplayItems: [],
            documentURL: "",
            matterlistUrl: "",
        };
   

        EventEmitter.subscribe("apply-filters", (param: any) => {
            this._tempFilter = param;
        });
    }

    componentDidMount() {
        this.getUserCredentials().then((res) => {
            let user = JSON.parse(res);
            this.setState(
                {
                    userName: user.userName,
                    //userName: 'ebarroga91@rouse.com',
                },
                () => {
                    this.getAPI().then((apiRes) => {
                        let api = JSON.parse(apiRes);
                        this.setState(
                            {
                                documentURL: api.matterdetail,
                                matterlistUrl: api.matterlistUrl,
                            },
                            () => {
                                this._getDataList(1);
                            },
                        );
                    });
                },
            );
        });
    }

    getUserCredentials() {
        return new Promise((resolve) => {
            resolve(localStorage.getItem("userSession"));
        });
    }

    getAPI() {
        return new Promise((resolve) => {
            resolve(localStorage.getItem("api"));
        });
    }

    _getDataList = (page: any) => {
        this.createColumns();

        const param = {
            token: "32e5ae47-8d89-4422-9004-8a238f1707fb",
            filter: "recentcases",
            userId: this.state.userName, //'ebarroga91@rouse.com',
            casemanager: this.state.userName, //'ebarroga91@rouse.com'
        };
        axios
            .post(this.state.matterlistUrl, JSON.stringify(param))
            .then((response) => {
                let tempItems = this.state.items;
                if (page === 1) tempItems = [];

                for (let x = 0; x < response.data.length; x++) {
                    if (response.data[x] !== null) {
                        tempItems.push(response.data[x].data.summary);
                    }
                }

                this.setState({
                    items: tempItems,
                    displayItems: tempItems,
                    prevDisplayItems: tempItems,
                    blocking: false,
                    settingsMenu: this.createSettingsMenu(),
                });
            })
            .catch(() => {
                this.setState({
                    blocking: false,
                    settingsMenu: this.createSettingsMenu(),
                });
            });
    };

    onColumnHeaderClick = (ev: any, column: any) => {
        this.setState({
            contextualMenuProps: this.getContextualMenuProps(ev, column),
        });
    };

    getContextualMenuProps(env: any, column: any) {
        const items = [
            {
                key: "aToZ",
                name: "Ascending",
                iconProps: { iconName: "SortUp" },
                canCheck: true,
                disabled: false,
                onClick: () => this.onSortingClicked(column, true),
            },
            {
                key: "zToA",
                name: "Descending",
                iconProps: { iconName: "SortDown" },
                canCheck: true,
                disabled: false,
                onClick: () => this.onSortingClicked(column, false),
            },
        ];

        if (column.isFilterable === true) {
            items.push({
                key: "filter",
                name: "Filter by " + column.name,
                iconProps: { iconName: "Filter" },
                canCheck: true,
                disabled: false,
                onClick: () => this.onFilterClicked(column),
            });

            items.push({
                key: "clearFilter",
                name: "Clear Filter",
                iconProps: { iconName: "ClearFilter" },
                canCheck: true,
                disabled: column.isFiltered === true ? false : true,
                onClick: () => this.onFilterClear(column),
            });
        }

        return {
            items: items,
            target: env.currentTarget,
            directionalHint: DirectionalHint.bottomLeftEdge,
            onDismiss: () => this.onContextualMenuDismissed(),
        };
    }

    onSortingClicked(column: any, isAscending: boolean) {
        let currItems = this.state.displayItems;
        let columns = this.state.columns;
        let isSortedDescending = column.isSortedDescending;

        if (column.isSorted) {
            isSortedDescending = isAscending ? false : true;
        }

        let sortedItem = currItems.slice(0).sort(this.alphabetically(!isSortedDescending, column.key));

        this.setState({
            displayItems: sortedItem,
            columns: columns.map((col) => {
                col.isSorted = col.key === column.key;
                if (col.isSorted) {
                    col.isSortedDescending = isSortedDescending;
                }
                return col;
            }),
        });
    }

    alphabetically(ascending: any, key: any) {

        return function (a, b) {

            // nulls sort after anything else
            if ((a[key] === null && !ascending) || (b[key] === null && ascending)) {
                return 1;
            }
            else if ((b[key] === null && !ascending) || (a[key] === null && ascending)) {
                return -1;
            }
            // equal items sort equally
            else if (a[key].toLowerCase() === b[key].toLowerCase()) {
                return 0;
            }
            // otherwise, if we're ascending, lowest sorts first
            else if (ascending) {
                return a[key].toLowerCase() < b[key].toLowerCase() ? -1 : 1;
            }
            // if descending, highest sorts first
            else {
                return a[key].toLowerCase() < b[key].toLowerCase() ? 1 : -1;
            }

        };

    }

    onFilterClicked(column: any) {
        this._tempFilter = { column: column.key, values: column.SelectedValues };
        this.setState({
            openPanel: true,
            filterColumn: column,
            filterColumnName: "Filter By " + column.name,
        });
    }

    onPanelDismissed() {
        this.setState({
            openPanel: false,
        });
    }

    onContextualMenuDismissed() {
        this.setState({
            contextualMenuProps: undefined,
        });
    }

    createColumns() {
        const generatedColumns = [];

        for (let i = 0; i < this.state.tempColumns.length; i++) {
            if (this.state.tempColumns[i].isHidden === false) {
                generatedColumns.push(this.state.tempColumns[i]);
            }
        }

        this.setState({
            columns: generatedColumns,
        });
    }

    _createColumnList() {
        const columnList = [];

        for (let i = 0; i < this.state.tempColumns.length; i++) {
            const tempItem = {
                key: this.state.tempColumns[i].fieldName,
                text: this.state.tempColumns[i].name,
                iconProps: {
                    iconName: this.state.tempColumns[i].isHidden
                        ? "Checkbox"
                        : "CheckboxComposite",
                },
                onClick: () => this._onShowHideColumn(this.state.tempColumns[i].key),
            };
            columnList.push(tempItem);
        }

        return columnList;
    }

    _onShowHideColumn = (column: string) => {
        const _tempColumnList = this.state.tempColumns;

        for (let x = 0; x < _tempColumnList.length; x++) {
            if (column === _tempColumnList[x].key) {
                if (_tempColumnList[x].isHidden === false) {
                    _tempColumnList[x].isHidden = true;
                } else {
                    _tempColumnList[x].isHidden = false;
                }
            }
        }
        this.setState(
            {
                settingsMenu: this.createSettingsMenu(),
            },
            () => this.createColumns(),
        );
    };

    _resetCheckbox = () => {
        this.setState({
            settingsMenu: this.createSettingsMenu()
        });

        return;
    }

    createSettingsMenu() {
        const menuItem = [
            {
                key: "resetColumn",
                text: "Reset Column State",
                iconProps: { iconName: "TripleColumn" },
                disabled: false,
                onClick: () => {
                    /*Reset default cols*/

                    let _currentColumns = this.state.tempColumns;
                    let currItems = this.state.displayItems;

                    let activCols = this.state.activeCols;
                    var colsCur = [];
                    for (let x = 0; x < _currentColumns.length; x++) {
                        _currentColumns[x].isFiltered = false;
                        _currentColumns[x].SelectedValues = [];

                        /*Sort*/
                        let isSortedDescending = _currentColumns[x].isSortedDescending;
                        if (isSortedDescending) {
                            isSortedDescending = false;
                        }

                        let sortedItem = currItems.slice(0).sort(this.alphabetically(!isSortedDescending, _currentColumns[x].key));
                        _currentColumns[x].isSortedDescending = isSortedDescending;
                        _currentColumns[x].isSorted = isSortedDescending;

                        if (activCols.filter(c => c == _currentColumns[x].key).length > 0) {
                            _currentColumns[x].isHidden = false;
                            colsCur.push(_currentColumns[x]);
                        }
                       
                    }
                    this._tempFilter = [];

                    this.setState({
                        columns: colsCur,
                        displayItems: []
                    }, function () {
                        this._resetCheckbox();
                        this._onImplementFilter();
                    });
                }
            },
            {
                key: "columns",
                text: "Columns",
                iconProps: { iconName: "TripleColumnEdit" },
                disabled: false,
                subMenuProps: {
                    items: this._createColumnList(),
                },
            },
        ];

        return {
            shouldFocusOnMount: false,
            items: menuItem,
        };
    }

    onFilterApply() {
        let _currentColumns = this.state.columns;
        for (var x = 0; x < _currentColumns.length; x++) {
            if (_currentColumns[x].key === this._tempFilter.column) {
                _currentColumns[x].isFiltered = true;
                _currentColumns[x].SelectedValues = this._tempFilter.values;
                break;
            }
        }
        this.setState({
            columns: _currentColumns,
            openPanel: false
        }, function () {
            this._onImplementFilter();
        });
    }

    _onImplementFilter() {
        let _filteredItems = JSON.parse(JSON.stringify(this.state.items));
        let _currentColumns = this.state.columns;
        let _activeFilters = [];
        for (var x = 0; x < _currentColumns.length; x++) {
            if (_currentColumns[x].isFiltered) {
                _activeFilters.push(_currentColumns[x]);
            }
        } 
        for (var x = _filteredItems.length - 1; x >= 0; x--) {
            var spliced = false;
            for (var i = 0; i < _activeFilters.length; i++) {
                if (_activeFilters[i].data === "date") {
                   
                    if (_activeFilters[i].SelectedValues[0] != undefined && _activeFilters[i].SelectedValues[1] == undefined) {
                        if (Moment(_filteredItems[x][_activeFilters[i].key], "YYYY-MM-DD") <= Moment(_activeFilters[i].SelectedValues[0], "YYYY-MM-DD")) {
                            spliced = true;
                            break;
                        }
                    }
                    if (_activeFilters[i].SelectedValues[1] != undefined && _activeFilters[i].SelectedValues[0] == undefined) {
                        if (Moment(_filteredItems[x][_activeFilters[i].key], "YYYY-MM-DD") >= Moment(_activeFilters[i].SelectedValues[1], "YYYY-MM-DD")) {
                            spliced = true;
                            break;
                        }
                    }
                    if (_activeFilters[i].SelectedValues[0] != undefined && _activeFilters[i].SelectedValues[1] != undefined) {
                        if (Moment(_filteredItems[x][_activeFilters[i].key], "YYYY-MM-DD") <= Moment(_activeFilters[i].SelectedValues[0], "YYYY-MM-DD") ||
                            Moment(_filteredItems[x][_activeFilters[i].key], "YYYY-MM-DD") >= Moment(_activeFilters[i].SelectedValues[1], "YYYY-MM-DD")) {
                            spliced = true;
                            break;
                        }
                    }
                }
                else {
                    if (_activeFilters[i].SelectedValues.indexOf(_filteredItems[x][_activeFilters[i].key]) === -1) {
                        spliced = true;
                        break;
                    }
                }
            }
            if (spliced) {
                _filteredItems.splice(x, 1);
            }
        }
        this.setState({
            displayItems: _filteredItems
        })
    }

    onFilterClear(column) {
        let _currentColumns = this.state.columns;
        for (let x = 0; x < _currentColumns.length; x++) {
            if (column.key == _currentColumns[x].key) {
                _currentColumns[x].isFiltered = false;
                _currentColumns[x].SelectedValues = [];
                break;
            }
        }
        this._tempFilter = [];

        this.setState({
            columns: _currentColumns,
        }, function () {
            this._onImplementFilter();
        });
    }

    public render() {
        const { contextualMenuProps } = this.state;

        const onRenderFooterContent = () => (
            <div>
                <PrimaryButton
                    onClick={() => this.onFilterApply()}
                    style={{ marginRight: "8px" }}
                >
                    Apply
        </PrimaryButton>
                <DefaultButton onClick={() => this.onPanelDismissed()}>
                    Cancel
        </DefaultButton>
            </div>
        );

        return (
            <form
                action={this.state.formActionURL}
                target={this.state.formTarget}
                method="post"
            >
                <input type="hidden" name="token" value={this.state.token}></input>
                <input type="hidden" name="image" value={this.state.image}></input>
                <input type="hidden" name="name" value={this.state.name}></input>
                <input
                    type="hidden"
                    name="userName"
                    value={this.state.userName}
                ></input>
                <input
                    type="hidden"
                    name="originalIUrl"
                    value={this.state.originalURL}
                ></input>
                <input type="hidden" name="userId" value={this.state.userId}></input>

                <div>
                    {this.state.blocking === true ? (
                        <Spinner
                            className="list-spinner"
                            size={SpinnerSize.large}
                            label="Loading..."
                            ariaLive="assertive"
                            labelPosition="top"
                        />
                    ) : (
                            ""
                        )}
                    <div className="settings-menu">
                        <DefaultButton
                            iconProps={{ iconName: "Settings" }}
                            menuProps={this.state.settingsMenu}
                            className="menu-button"
                        ></DefaultButton>
                    </div>
                    <div className="list-container">
                        <Stack horizontal tokens={stackTokens}>
                            <Stack.Item align="stretch">
                                <ScrollablePane>
                                    <ShimmeredDetailsList
                                        setKey="items"
                                        items={this.state.displayItems}
                                        columns={this.state.columns}
                                        isHeaderVisible={true}
                                        layoutMode={DetailsListLayoutMode.justified}
                                        constrainMode={ConstrainMode.unconstrained}
                                        onColumnHeaderClick={this.onColumnHeaderClick}
                                        selectionMode={SelectionMode.single}
                                        listProps={{
                                            renderedWindowsAhead: 0,
                                            renderedWindowsBehind: 0,
                                        }}
                                        onRenderDetailsHeader={(
                                            detailsHeaderProps: IDetailsHeaderProps,
                                            defaultRender: IRenderFunction<IDetailsHeaderProps>,
                                        ) => <Sticky>{defaultRender(detailsHeaderProps)}</Sticky>}
                                    />
                                </ScrollablePane>
                                {contextualMenuProps && (
                                    <ContextualMenu {...contextualMenuProps} />
                                )}
                            </Stack.Item>
                        </Stack>
                    </div>

                    <Panel
                        headerClassName="filter-panel"
                        isOpen={this.state.openPanel}
                        onDismiss={() => this.onPanelDismissed()}
                        headerText={this.state.filterColumnName}
                        type={PanelType.custom}
                        customWidth="400px"
                        onRenderFooterContent={onRenderFooterContent}
                        isFooterAtBottom={true}
                    >
                        <Filters
                            items={
                                this.state.filterColumn.isFiltered
                                    ? this.state.items
                                    : this.state.displayItems
                            }
                            selectedItems={this._tempFilter}
                            column={this.state.filterColumn}
                            tempFilter={this._tempFilter}
                        ></Filters>
                    </Panel>
                </div>
            </form>
        );
    }
}

export default MatterList;
